//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Edición de talle de prenda

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Notify from "../../Notify";
import { putData } from "../../../services/library";

function EdicionTalle(props) {
  const [talle, setTalle] = useState(props.talle);
  const [disBtn, setDisBtn] = useState(false);
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const handleClose = () => {
    props.onClose(false);
  };
  const almacenar = (e) => {
    setTalle({
      ...talle,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };
  // console.log(talle);

  async function guardarTalle(e) {
    // setDisBtn(true);
    putData(
      e,
      "/stock_prendas_talles/" + talle.id,
      {
        talle: talle.talle,
        descripcion: talle.descripcion,
      },
      setNotificacion
    );
  }

  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.onClose(false);
              //   props.actualizar();
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar Talle {props.talle.talle}
            </Typography>
          </DialogTitle>
        </Box>
        <form onSubmit={guardarTalle}>
          <DialogContent>
            <Box
              //   backgroundColor="#F4F6F6"
              px={2}
              py={2}
              //   border={0.5}
              //   borderColor={"#ABB2B9"}
              borderRadius={3}
            >
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    focused
                    style={style}
                    placeholder="Talle"
                    type="text"
                    required
                    name="talle"
                    label="Talle"
                    onChange={almacenar}
                    value={talle.talle}
                    inputProps={{ maxLength: 200 }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    size="small"
                    style={style}
                    placeholder="Descripción"
                    type="text"
                    // inputProps={{ maxLength: 6 }} //solo 2 numeros
                    focused
                    name="descripcion"
                    label="Descripción"
                    color="primary"
                    onChange={almacenar}
                    value={talle.descripcion}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={1}
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => handleClose()}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button type="submit" color="success" variant="contained">
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </form>
      </Dialog>
    </div>
  );
}

export default EdicionTalle;
